import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ProfileImageService } from 'src/app/shared/services/profile-image-service.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-profile-image-dialog',
  templateUrl: './profile-image-dialog.component.html',
  styleUrls: ['./profile-image-dialog.component.scss']
})
export class ProfileImageDialogComponent {
  profileImageUrl: string | ArrayBuffer | null;
  selectedFile: File | null = null;
  userId: number;
  currentUser: any = {};
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProfileImageDialogComponent>,
    private profileImageService: ProfileImageService,
    private _authService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.profileImageUrl = data.profileImageUrl;
    this.currentUser = this._authService.currentUserValue;
    this.userId = this.currentUser.user_id;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      // aca verificamos el tamaño del archivo (por ejemplo, 5MB)
      const maxSizeInMB = 5;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        Swal.fire('Error', `El archivo es demasiado grande. El tamaño máximo permitido es ${maxSizeInMB}MB.`, 'error')
        return;
      }

      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const target = e.target as FileReader;
        if (target && target.result) {
          this.profileImageUrl = target.result;
        }
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  isPhotoDeleted: boolean = false;

  onDeletePhoto(): void {
    
    this.isPhotoDeleted = true;
    
 
    this.profileImageUrl = null;
    this.selectedFile = null;
  }

  onSave(): void {
    if (this.isPhotoDeleted) {
     
      this.isLoading = true;
      this.profileImageService.deleteProfileImage(this.userId).subscribe(
        () => {
         
          this.profileImageService.setProfileImageUrl('assets/img/user.svg');
          this.isLoading = false;
          this.dialogRef.close();
          Swal.fire('Éxito', 'La imagen de perfil se ha eliminado correctamente.', 'success');
        },
        (error) => {
        
          this.isLoading = false;
          Swal.fire('Error', 'Hubo un error al eliminar la imagen de perfil.', 'error');
         
        }
      );
    } else if (this.selectedFile) {
     
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('userId', this.userId.toString());
  
      this.profileImageService.uploadProfileImage(formData).subscribe(
        (response) => {
         
          const reader = new FileReader();
          reader.onloadend = () => {
            const imageUrl = reader.result as string;
            this.profileImageService.setProfileImageUrl(imageUrl);
            this.isLoading = false;
            this.dialogRef.close();
            Swal.fire('Éxito', 'La imagen de perfil se ha actualizado correctamente.', 'success');
          };
          reader.readAsDataURL(this.selectedFile);
        },
        (error) => {
    
          this.isLoading = false;
          Swal.fire('Error', 'Hubo un error al subir la imagen. Por favor, inténtalo de nuevo.', 'error');
         
        }
      );
    } else {
      
      Swal.fire('Error', 'No se ha seleccionado ninguna imagen o acción.', 'error');
     
    }
  }
  onCancel(): void {
    this.dialogRef.close();
  }
}